import axios from '@axios'
import { apiDomain, authDomain } from '@src/app.config.json'
export const state = {
  currentUser: getSavedState('autoAuth.currentUser'),
  userProfile: {},
}

export const mutations = {
  UPDATE_SUBSCRIBE(state, products) {
    let subscriptions = []
    products.subscription.forEach((element) => {
      subscriptions.push(element.slush)
    })
    state.currentUser.subscriptions = subscriptions
  },
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('autoAuth.currentUser', newValue)
  },
  SET_CURRENT_USER_PROFILE_PICTURE(state, pictureUrl) {
    if (pictureUrl) {
      let clonedProfile = Object.assign({}, state.userProfile)
      clonedProfile.photo = pictureUrl.photo
      state.userProfile = clonedProfile
    }
  },
  SET_BALANCE(state, balance) {
    state.currentUser.balance = balance
    saveState('autoAuth.currentUser', state.currentUser)
  },

  SET_PROFILE(state, profile) {
    if (profile) {
      state.currentUser = profile
      saveState('autoAuth.currentUser', state.currentUser)
    }
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
  isAdmin(state) {
    if (state.currentUser) {
      return (
        state.currentUser.type === 'admin' || state.currentUser.type === 'staff'
      )
    }
    return false
  },
  superAdmin() {
    return state.currentUser ? state.currentUser.type === 'admin' : false
  },
  isPrivateCustomer(state) {
    if (state.currentUser) {
      return state.currentUser.type === 'private_customer'
    }
    return false
  },
  isBroker(state) {
    if (state.currentUser) {
      return state.currentUser.type === 'broker'
    }
    return false
  },
  isEndUser(state) {
    if (state.currentUser) {
      return state.currentUser.type === 'end_user'
    }
    return false
  },
  isWarehouse(state) {
    if (state.currentUser) {
      return state.currentUser.type === 'warehouse'
    }
    return false
  },
  isFinanceire(state) {
    if (state.currentUser) {
      return state.currentUser.type === 'financeire'
    }
    return false
  },
  isSubAccount(state) {
    if (state.currentUser) {
      return !!state.currentUser.parent_id === true
    }
    return false
  },
  currentUser: (state) => state.currentUser,
  userProfile: (state) => state.userProfile,
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit }, { username, password } = {}) {
    return axios
      .post(`${authDomain}/api/login`, {
        username: username,
        password: password,
      })
      .then((response) => {
        if (response.status === 200) {
          let user = response.data
          commit('SET_CURRENT_USER', user)
          return user
        }
        return response
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
  },

  // register the user
  register({ commit, dispatch, getters }, new_user = {}) {
    if (getters.loggedIn) {
      return dispatch('validate')
    }
    return axios
      .post(`${authDomain}/auth/signup`, new_user)
      .then((response) => {
        const user = response.data
        return user
      })
  },

  activateOTP({ commit, dispatch, getters }, OTP) {
    if (getters.loggedIn) return dispatch('validate')
    return axios.post(`${authDomain}/auth/activate`, { token: OTP })
  },
  // register the user
  resetPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    const formData = new FormData()
    formData.append('email', email)
    return axios.post('/account-recovery', formData).then((response) => {
      const message = response.data
      return message
    })
  },
  // forget passwor
  forgetPassword({ cmmit, dispatch, getters }, data = {}) {
    if (getters.loggedIn) return dispatch('validate')
    return axios.post(`${authDomain}/auth/reset-password`, data)
  },
  // verify token and update new password
  UpdateNewPassword({ commit, dispatch, getters }, data = {}) {
    if (getters.loggedIn) return dispatch('validate')
    return axios.patch(`${authDomain}/auth/update-password`, data)
  },

  newPassword({ commit, dispatch, getters }, { data } = {}) {
    if (getters.loggedIn) return dispatch('validate')
    const formData = new FormData()
    formData.append('password', data.password)
    return axios.post(`/forget-password/${data.token}`, formData)
  },
  // register the user
  changePassword({ commit, dispatch, getters }, { email, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    const formData = new FormData()
    formData.append('email', email)
    formData.append('password', password)
    return axios.post('/reset-password', formData).then((response) => {
      const message = response.data
      return message
    })
  },

  requestNewPassword({ commit }, newPassword = {}) {
    return axios.post('/auth/change-password', newPassword)
  },

  resentToken({ commit }, email = {}) {
    return axios.post(`${authDomain}/auth/resend-token`, email)
  },

  // register the user
  recovery({ commit, dispatch, getters }, { token } = {}) {
    const formData = new FormData()
    formData.append('token', token)
    return axios.post('/recovery/' + token, formData).then((response) => {
      const message = response.data
      return message
    })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state, getters }, routeTo) {
    if (routeTo !== undefined) {
      // reset based URL
      if (routeTo.name === 'login' || routeTo.name === 'logout')
        setDefaultBaseURL(false)
    } else {
      setDefaultBaseURL(getters.isAdmin)
    }

    return state.currentUser ? state.currentUser : null
  },

  verifyUser({ commit, state }, account) {
    // Reset login url
    axios.defaults.baseURL = apiDomain

    return axios.post('/login', account).then((resp) => {
      if (resp.status === 200) {
        setDefaultBaseURL(state.currentUser.is_admin)
        commit('SET_CURRENT_USER', resp.data)
      }
      return resp.data
    })
  },

  async confirmToken({ commit }, user) {
    return axios.post(`/confirm`, user)
  },

  async verifyRecaptcha({ commit }, token) {
    return axios.get(`${authDomain}/auth/verify-recaptcha`, {
      params: { response: token },
    })
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

function setDefaultBaseURL(isAdmin) {
  if (isAdmin) {
    axios.defaults.baseURL = apiDomain
    axios.defaults.baseURL += `/admin`
  } else {
    axios.defaults.baseURL = apiDomain
  }
}
